import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import ReactDOM from 'react-dom';
import styles from './Select.scss';

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false
    }
  }
  focusHandler = () => {
    this.setState({ focused: true })
  }
  changedHandler = (event) => {
    this.props.changed(event, this.props.identifier);
    ReactDOM.findDOMNode(this).blur();
  }
  blurHandler = (event) => {
    this.setState({ focused: false });
  }
  render() {
    return (
  		<select className={styles.defaultSelect}
              onChange={this.changedHandler}
              placeholder={this.props.placeholder}
              value={this.props.value}
              data-hasvalue={(this.props.value !== null && this.props.value !== "") || this.state.focused ? true : false}
              disabled={this.props.disabled ? true : false}
              onFocus={this.focusHandler}
              onBlur={this.blurHandler}>
              {!this.props.isRequired ? (<option value="">{this.props.translate('global.form.select.default')}</option>) : null}
      {this.props.options.map((option, index) =>
        <option key={index} value={option.value}>{option.name}</option>
      )}
      </select>
    )
  }
}

const mapStateToProps = state => {
    return {
        translate: getTranslate(state.locale)
    };
};
export default connect(mapStateToProps)(Select);


// WEBPACK FOOTER //
// ./src/components/atoms/Select/index.js